module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/228-nauru-bef57700a7a6ccd4ae4dd56e5cd670c2.svg";